import Box from "./Box";

export type { BoxProps } from "./Box";
export default Box;
